import { defineComponent } from 'vue';

export default defineComponent({
    name: 'LazyLoadEVentMixin',
    emits: ['uploading'],
    data() {
        return {
            isLoading: false,
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.$Lazyload.$on('loading', this.handleLoading);
            this.$Lazyload.$on('loaded', this.handleLoaded);
            this.$Lazyload.$on('error', this.handleError);
        });
    },
    beforeUnmount() {
        this.$Lazyload.$off('loading', this.handleLoading);
        this.$Lazyload.$off('loaded', this.handleLoaded);
        this.$Lazyload.$off('error', this.handleError);
    },
    methods: {
        handleLoading() {
            this.isLoading = true;
            this.emitLoadingStatus(true);
        },
        handleLoaded() {
            this.isLoading = false;
            this.emitLoadingStatus(false);
        },
        handleError() {
            this.isLoading = false;
            this.emitLoadingStatus(false);
        },
        emitLoadingStatus(status) {
            this.$emit('uploading', status);
        },
    },
});
